import { InputHTMLAttributes, forwardRef, useState } from 'react';
import { EyeIcon, EyeOffIcon } from '../icons';

interface PasswordInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  error?: string;
  hint?: string;
}

/**
 * Campo de clave con boton de "ojito" para mostrar/ocultar el texto mientras
 * se escribe - util sobre todo cuando un administrador esta asignando la
 * clave de otra persona (Configuracion > Usuarios > Agregar) y necesita
 * confirmar que quedo bien escrita antes de entregarsela.
 */
export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(function PasswordInput(
  { label, error, hint, className = '', id, ...rest },
  ref
) {
  const [visible, setVisible] = useState(false);

  return (
    <label className="block w-full">
      {label && <span className="mb-1.5 block text-sm font-medium text-ink-700">{label}</span>}
      <div className="relative">
        <input
          ref={ref}
          id={id}
          type={visible ? 'text' : 'password'}
          className={[
            'h-[50px] w-full rounded-xl border bg-surface px-4 pr-11 text-[15px] text-ink-800',
            'placeholder:text-ink-400 transition-colors duration-200',
            'focus:outline-none focus:ring-2 focus:ring-brand-200 focus:border-brand-400',
            error ? 'border-critical' : 'border-ink-200',
            className,
          ].join(' ')}
          {...rest}
        />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          tabIndex={-1}
          aria-label={visible ? 'Ocultar clave' : 'Mostrar clave'}
          title={visible ? 'Ocultar clave' : 'Mostrar clave'}
          className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-ink-400 hover:text-ink-600"
        >
          {visible ? <EyeOffIcon width={18} height={18} /> : <EyeIcon width={18} height={18} />}
        </button>
      </div>
      {error ? (
        <span className="mt-1 block text-xs text-critical">{error}</span>
      ) : hint ? (
        <span className="mt-1 block text-xs text-ink-400">{hint}</span>
      ) : null}
    </label>
  );
});
